import { useIntercomUserQuery } from "../../api/intercom/useIntercomUserQuery";
import { authService } from "../../services/AuthService";
import { intercomService } from "../../services/IntercomService";

export function IntercomMessenger() {
  const authData = authService.getLoginData();

  useIntercomUserQuery({
    payload: {
      wpuId: authData.wpuId,
    },
    options: {
      enabled: !!authData.wpuId,
      onSuccess: (data) => {
        intercomService.boot({
          app_id: data?.appId,
          user_id: data.id,
          name: `${data.firstname} ${data.lastname}`,
          email: data.email_id,
          created_at: data.created,
          company: {
            id: data.company_id,
            name: data.company_name,
          },
        });
      },
    },
  });

  return null;
}
